import { type ReactNode } from 'react'
import { cn } from '~/utils/cn'
import { AccountMenu } from './AccountMenu'
// import { ProgressBar } from './Evaluation/ProgressBar'
import { AccountAvatar } from './AccountMenu/AccountAvatar'

type AppNavigationProps = {
  children: ReactNode
  left?: ReactNode
  right?: ReactNode
  bgColor?: string
  pendingTasks?: number
  loadingProgress?: number
}

const Divider = ({ children }: { children: ReactNode }) => (
  <div className="flex items-center pl-4 h-12 border-l border-l-gray-200">
    {children}
  </div>
)

export const AppNavigation = ({
  left,
  children,
  pendingTasks = 0,
  bgColor = 'bg-white',
}: AppNavigationProps) => {
  return (
    <nav
      className={cn(
        'w-full border-b border-gray-200 sticky top-0 z-[999] h-12 print:hidden',
        bgColor
      )}
      data-pdf-remove
    >
      <div className="flex md:gap-x-3 items-center px-3">
        <div className="flex-shrink">{left}</div>
        <div className="flex-1 w-full flex items-center gap-x-3 h-full pr-2 md:pr-0">
          {children}
        </div>
        <div className="ml-auto flex-shrink flex flex-row items-center gap-x-3 h-full">
          <Divider>
            <AccountMenu>
              <AccountAvatar />
            </AccountMenu>
          </Divider>
        </div>
      </div>
      {/* TODO: Get rid of it if not required in the future */}
      {/* <ProgressBar pendingTasks={pendingTasks} /> */}
    </nav>
  )
}
